import './EditableInput.scss';
import { FieldHelperProps, useField } from 'formik';
import { FocusEventHandler, ChangeEvent } from 'react';
import { USDollar } from '@luna-protocol/core/src/utils/constants/format.ts';

interface EditableInputProps {
  label?: string;
  placeholder?: string;
  value?: string | number | undefined;
  onChange?: (newValue: string | number | undefined) => void;
  onFormikValueChange?: (newValue: string | number | undefined) => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  name?: string;
  disabled?: boolean;
  error?: string;
  disclaimer?: string;
  required?: boolean;
  className?: string;
  formik?: boolean;
  editable?: boolean;
  viewOnly?: boolean;
  testId?: string;
  type?: string;
}

const EditableInput = ({
  label,
  placeholder,
  value,
  onChange,
  name,
  disabled = false,
  formik = true,
  required,
  onBlur,
  className,
  editable = false,
  viewOnly = false,
  testId,
  type = 'text',
  onFormikValueChange,
}: EditableInputProps) => {
  let formikHelpers: FieldHelperProps<unknown>;
  if (formik) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [, , helpers] = useField(name || '');
    formikHelpers = helpers;
  }
  
  const getStringValue = (value: string | number | undefined) =>
    value !== undefined && value !== null ? String(value) : '';

  const displayValue = getStringValue(value);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (formik) {
      formikHelpers.setValue(newValue, true);
      if (onFormikValueChange) {
        onFormikValueChange(newValue);
      }
    }

    onChange && onChange(newValue);
  };

  const isPriceOrInvoice = label?.toLowerCase().includes('price') || label?.toLowerCase().includes('invoice') || label?.toLowerCase().includes('nada');

  return (
    <div className={`select--input--container--editable ${className ? className : ''}`}>
      <label htmlFor={name} className="label">
        {label}
      </label>
      {!editable ? (
        <p className={viewOnly ? 'value-right' : 'value-right editable'}>
          {isPriceOrInvoice ? USDollar.format(Number(displayValue)) : displayValue}
        </p>
      ) : (
        <>
          <input
            type={type}
            name={name}
            id={name}
            value={displayValue}
            onChange={handleInputChange}
            onBlur={onBlur}
            disabled={disabled}
            required={required}
            placeholder={placeholder}
            data-testid={`${testId || name}-input`}
            className="select-input"
            onWheel={e => e.currentTarget.blur()}
          />
        </>
      )}
    </div>
  );
};

export default EditableInput;
